import React, {useMemo} from "react";
import CanvasJSReact from "../../../assets/canvasjs.react";
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const TestResultChart = ({totalCount = 0, dataPoints = []}) => {
    const options = useMemo(() => ({
        animationEnabled: true,
        exportEnabled: true,
        theme: "light2",
        title: { text: `Výsledky testů (∑ ${totalCount})` },
        axisY: { title: "Uživatelé", includeZero: true },
        axisX: { title: "Body z testu", interval: 2 },
        data: [{
            type: "line",
            toolTipContent: "{y} uživatelů s {x} body",
            dataPoints
        }]
    }), [totalCount, dataPoints]);

    return <CanvasJSChart options={options} />;
};

export default TestResultChart;
